<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="12" sm="12">
        <h2>Home</h2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Home",
};
</script>
